import { UdeuStatus } from "./udeu-status";

export class UdeuStatusMultiple {
    UUIDs: string[];
    status: UdeuStatus;

    constructor(UUIDs: string[], status?: UdeuStatus) {
        this.UUIDs = UUIDs;
        this.status = status;
    }
}